(() => {
  if (window.LandingCart) return;
  const base = window.Shopify?.routes?.root || '/';
  const roots = () => [...document.querySelectorAll('[data-lc-root]')];
  let busy = false;
  let previousFocus;
  let previousOverflow;
  const parse = async response => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'No se ha podido actualizar el carrito.');
    return data;
  };
  const showError = (root, message) => {
    let el = root.querySelector('[data-lc-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'lc-error'; el.setAttribute('role', 'alert');
      root.querySelector('[data-lc-content]').append(el);
    }
    el.hidden = false; el.textContent = message;
  };
  const count = value => document.querySelectorAll('[data-lc-count], [data-cart-count]').forEach(el => { el.textContent = value; });
  async function refresh(root) {
    const url = new URL(location.href);
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', root.dataset.section);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('No se ha podido cargar el carrito. Vuelve a intentarlo.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = doc.querySelector('[data-lc-content]');
    if (!content) throw new Error('No se ha podido cargar el carrito.');
    root.querySelector('[data-lc-content]').replaceWith(content);
    const updatedCount = root.querySelector('.lc-count');
    if (updatedCount) count(updatedCount.textContent);
  }
  function close() {
    const dialog = document.querySelector('[data-lc-dialog]');
    if (!dialog?.open) return;
    dialog.close();
  }
  async function open() {
    const dialog = document.querySelector('[data-lc-dialog]');
    if (!dialog) { location.href = base + 'cart'; return; }
    if (!dialog.open) {
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }
    const root = dialog.querySelector('[data-lc-root]');
    root.setAttribute('aria-busy', 'true');
    const checkout = root.querySelector('[data-lc-checkout]');
    if (checkout) checkout.disabled = true;
    try { await refresh(root); }
    catch (error) {
      showError(root, error.message);
      const link = document.createElement('a');
      link.href = base + 'cart'; link.className = 'lc-primary'; link.textContent = 'Ver el carrito'; root.querySelector('[data-lc-content]').append(link);
    } finally { root.removeAttribute('aria-busy'); }
  }
  async function change(root, key, quantity) {
    if (busy || root.hasAttribute('aria-busy')) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    const errorEl = root.querySelector('[data-lc-error]');
    if (errorEl) errorEl.hidden = true;
    root.querySelectorAll('button, input').forEach(el => { el.disabled = true; });
    const content = root.querySelector('.lc-items');
    const scrollTop = content?.scrollTop || 0;
    let committed = false;
    try {
      const cart = await fetch(base + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }), credentials: 'same-origin'
      }).then(parse);
      committed = true;
      count(cart.item_count);
      await refresh(root);
      const updatedItems = root.querySelector('.lc-items');
      if (updatedItems) updatedItems.scrollTop = scrollTop;
      const line = [...root.querySelectorAll('[data-lc-key]')].find(el => el.dataset.lcKey === key);
      const focusTarget = line?.querySelector('[data-lc-input]') || root.querySelector('[data-lc-checkout], [data-lc-close], .lc-primary');
      focusTarget?.focus({ preventScroll: true });
      const status = root.querySelector('[data-lc-status]');
      if (status) status.textContent = 'Carrito actualizado';
    } catch (error) {
      if (committed) { location.href = base + 'cart'; return; }
      const line = [...root.querySelectorAll('[data-lc-key]')].find(el => el.dataset.lcKey === key);
      if (line) line.querySelector('[data-lc-input]').value = line.dataset.lcQuantity;
      showError(root, error.message);
    } finally {
      busy = false; root.removeAttribute('aria-busy');
      root.querySelectorAll('button, input').forEach(el => { el.disabled = false; });
    }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-lc-open]');
    if (opener) { event.preventDefault(); open(); return; }
    const root = event.target.closest('[data-lc-root]');
    if (!root) return;
    if (event.target.closest('[data-lc-close]')) { close(); return; }
    const action = event.target.closest('[data-lc-step], [data-lc-pack], [data-lc-remove]');
    if (!action) return;
    event.preventDefault();
    const line = action.closest('[data-lc-key]');
    let quantity = Number(line.dataset.lcQuantity);
    if (action.hasAttribute('data-lc-remove')) quantity = 0;
    else if (action.hasAttribute('data-lc-pack')) quantity = Number(action.dataset.lcPack);
    else quantity = Math.max(0, quantity + Number(action.dataset.lcStep));
    change(root, line.dataset.lcKey, quantity);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-lc-input]')) return;
    const input = event.target;
    const root = input.closest('[data-lc-root]');
    const line = input.closest('[data-lc-key]');
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = line.dataset.lcQuantity; return;
    }
    change(root, line.dataset.lcKey, quantity);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-lc-form]');
    if (form && (busy || form.closest('[aria-busy=true]'))) event.preventDefault();
  });
  function bindDialogs() {
    document.querySelectorAll('[data-lc-dialog]').forEach(dialog => {
      if (dialog.dataset.lcBound) return;
      dialog.dataset.lcBound = 'true';
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow || '';
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
    });
  }
  bindDialogs();
  document.addEventListener('shopify:section:load', bindDialogs);
  window.LandingCart = { open, close, refresh: () => Promise.all(roots().map(refresh)) };
})();
